import { render, staticRenderFns } from "./birthdayRemindRegionPage.vue?vue&type=template&id=03ccfa84&scoped=true&"
import script from "./birthdayRemindRegionPage.vue?vue&type=script&lang=js&"
export * from "./birthdayRemindRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./birthdayRemindRegionPage.vue?vue&type=style&index=0&id=03ccfa84&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccfa84",
  null
  
)

export default component.exports